module.exports = __webpack_public_path__ + "static/img/price-center.2898e22a.svg";